<template>
  <v-row>
    <v-col cols="12">
      <v-autocomplete
        v-model="gruposContatosIdsLocale"
        dense
        outlined
        multiple
        clearable
        validate-on-blur
        label="Grupos de contatos"
        placeholder="Grupos de contatos"
        no-data-text="Nenhum grupo de contatos disponível"
        item-value="id"
        item-text="nome"
        :readonly="readonly"
        :filled="readonly"
        :loading="loading"
        :items="gruposContatos"
        @change="v => $emit('update:gruposContatosIds', v)"
      />
    </v-col>
  </v-row>
</template>

<script>
import { onMounted, ref, watch } from '@vue/composition-api'
import GruposContatosService from '@/services/modules/GruposContatosService'
import { formatarCelular } from '@/utils/formatting'

export default {
  props: {
    gruposContatosIds: {
      type: Array,
      default: null,
    },
    readonly: Boolean,
  },

  setup(props) {
    const gruposContatos = ref([])
    const gruposContatosIdsLocale = ref(null)
    const loading = ref(false)

    watch(
      () => props.gruposContatosIds,
      v => {
        if (!v) return
        gruposContatosIdsLocale.value = v
      },
      {
        immediate: true,
      },
    )

    async function getGruposContatos() {
      try {
        loading.value = true
        const res = await GruposContatosService.get()
        gruposContatos.value = res.filter(it => it.contatos.length)
      } finally {
        loading.value = false
      }
    }

    onMounted(getGruposContatos)

    return {
      gruposContatos,
      gruposContatosIdsLocale,
      loading,
      functions: {
        formatarCelular,
      },
    }
  },
}
</script>
